module.exports = __webpack_public_path__ + "static/media/close-icon.ee55b036.svg";